import axios from 'axios';

// TODO TRANSLATION: add query translation for products
export const getSearchedProducts = (query, lang) =>
   lang === 'eng' //
      ? axios.get(`/kns/products?query=${query}`)
      : axios.get(`/kns/products?query=${query}`);

export const getSearchedPriceList = (query) => axios.get(`/kns/price-list?query=${query}`);

export const getSearchedInstructions = (query) => axios.get(`/kns/instructions?query=${query}`);

export const getSearchedNews = (query) => axios.get(`/kns/news?query=${query}`);

export const getCatalogCategoriesNavItems = (lang) =>
   lang === 'eng' //
      ? axios.get('/wp-api-menus/v2/menus/440')
      : axios.get('/wp-api-menus/v2/menus/74');

export const getCatalogModelsNavItem = (lang) =>
   lang === 'eng' //
      ? axios.get('/wp-api-menus/v2/menus/441')
      : axios.get('/wp-api-menus/v2/menus/100');

export const getCatalogTagsNavItem = (lang) =>
   lang === 'eng' //
      ? axios.get('/wp-api-menus/v2/menus/809')
      : axios.get('/wp-api-menus/v2/menus/99');

export const getSingleProductNavItemsEng = () => axios.get('/wp-api-menus/v2/menus/439');

export const getSingleProductNavItemsUkr = () => axios.get('/wp-api-menus/v2/menus/4436');

export const getSingleProductNavItemsPol = () => axios.get('/wp-api-menus/v2/menus/72');

export const getSingleProductNavItemsGer = () => axios.get('/wp-api-menus/v2/menus/4489');
